module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-9"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Chapter Two")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_vm._v("The emotions that galloped across Jenna’s face in rapid succession—fear, shock, loathing—punched him in the gut.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But he had no time for explanations, no time for apologies. Two trained assassins lurked just blocks away.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Get in the back, Jenna, and duck down.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She hesitated for a split second, glanced at Gavin’s face, alert and curious, and started for the car.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade’s gaze roamed hungrily over Gavin’s small frame and regret crawled across his skin like a fungus. He had no time for remorse, either. Not now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As soon as Jenna threw open the back door to the car, Cade ducked back into the vehicle. When the door slammed, he peeled away from the curb with a squeal and heard a thump of bodies against the seat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Regret number two hundred and fifty-eight.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When he hit the intersection, he eased off the accelerator and stopped at the red light like a normal person. He looked in the rearview mirror, getting a glimpse of the top of Jenna’s head, disheveled blond hair gleaming in the wintry sun.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His California beach girl living in the snow. Never thought he’d live to see the day. Never thought he’d live to see a lot of days.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Scrunch down farther.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Who’s the man, Mommy?” Gavin’s head popped up and Jenna tugged him down again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“H-he’s going to give us a ride, Gavin.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade gulped back the dull rage and sharp words. What did he expect? He’d take being his son’s ride...for now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sirens blared amid the oncoming traffic and a cadre of emergency vehicles, lights flashing, turned the corner in front of him. Had the black truck caused more trouble on the street? Even the cops couldn’t stop the men in that truck. Not the entire Lovett Peak P.D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin’s head appeared in his rearview mirror again, bouncing up like a jack-in-the-box.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Stay down, Gavin. You’re not in your car seat, so you have to lie down, okay?” Jenna wrapped her arms around their squirrelly son and pulled him down.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin’s voice squeaked from the depths of the backseat. “Fire trucks!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I heard them. They’re gone already.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade eyed his side mirror as the last of the emergency vehicles took another turn...toward Jenna’s area of town.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Had they done something to Jenna’s little house?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He scanned the sky behind him, looking for smoke or some other sign of mayhem from that side of town. Because when those types of men appeared, mayhem followed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Of course, his track record wasn’t much better than theirs.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenna asked in a muffled voice, “Where are we going?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Away.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What are you doing here, Cade?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Long story.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She snorted and he could picture her rolling her baby blues. “When is it ever a short story?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Spy meets girl next door. Spy loses girl next door. Is that short enough for you?” Before she could respond, he whistled through his teeth. “Hello.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There’s a commotion up ahead.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What kind of commotion?” Fear edged Jenna’s voice, and Cade clutched the steering wheel, feeling her fear like a knife to the heart.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Looks like a car’s on fire.” Narrowing his eyes, he pumped the brakes. This four-lane road, two lanes in each direction, was the only way in and out of Lovett Peak. Now every car leaving town had to crawl past the accident, squeezing into one lane. Coincidence?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is there a black truck involved?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So she’d seen the truck. Damn. They’d gotten closer to her and Gavin than he’d expected.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not this time.” He cranked the wheel and pulled out of the line of cars, making a sharp right turn onto a small mountain access road that led back to Lovett Peak Ski Resort.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, no.” Jenna bolted upright in the seat. “We can’t go back to town.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He tipped his head toward the main road. “We can’t go out that way, either. Everyone going past that so-called accident is a sitting duck.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And what will we be in Lovett Peak?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ll be a family among other families.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She sucked in a noisy breath, but she didn’t respond. Trying to let the irony sink in most likely.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ll blend in. Have some dinner. Talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is that safe?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll protect you.” He’d been waiting three long years to say those words.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We can’t go to my house.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Of course not. It’s been compromised.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s been more than compromised.” She sniffled and coughed. “A dead body’s there.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade slammed on the brakes and lurched against his seat belt while the driver behind him leaned on his horn. “Gavin...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Conked out.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He blew out a breath. He didn’t think Jenna would be bringing up a dead body in front of their son. “Who was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My neighbor Marti. She scared them off with her gun, but they returned...with a bigger gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade pounded the steering wheel. “They were in your house with a weapon?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We hid the first time they were there, but they came back. They didn’t come in the house the second time. I think they were afraid the police would show up because Marti told them she’d called the cops.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did she?” The cops were never any use in these situations. He should know.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I wouldn’t let her.” She sniffled again. “I wish I had.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They shot her from outside?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They shot her with some kind of high-powered rifle with a silencer. The only thing I heard was the window shattering after the fact.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My God, Jenna. And you got on the bus after that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shot up in the backseat, her short, blond hair sticking up all over. “How do you know any of this? Why are you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Safety and food first.” He studied her tousled blond hair in the rearview mirror. “And a long, brown wig for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A wig?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You can make your transformation at the next gas station.” He jerked his thumb over his shoulder. “I have a bag in the back with some...stuff, disguises.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How did you...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Save it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She opened her mouth to say something, rolled her eyes and flopped back onto the seat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade knew the town of Lovett Peak, had studied maps and satellite pictures. Knew every mountain road, convenience store and pizza joint. But he still hadn’t gotten here in time.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His hands convulsively clutched the steering wheel when he thought about how close the assassins had come to Jenna and Gavin. If they had been successful...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Does anyone know you at Mike and Mo’s Service Station?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No. Lovett Peak’s not that small and I kept a low profile.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("How could a gorgeous, sun-kissed blonde keep a low profile in a land of snow bunnies? But Jenna had lost her surfer-girl tan, chopped off her hair and bundled herself in parkas and snow boots.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Checking his mirror for the hundredth time, Cade swung into Mike and Mo’s Service Station and parked around the back. No bathrooms on the outside meant bathrooms on the inside, and he didn’t want to wake up Gavin or send his mother inside on her own to make a quick change.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He popped the trunk. “I’ll get the stuff and you can change in the backseat.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just what am I changing?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Jacket for sure—that powder blue color is unmistakable—and your hair.” Prettiest color he’d ever seen, like a field of waving wheat on a summer day.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He slid from the seat, dragging his gun from the passenger seat next to him and shoving it into the back of his waistband. He hoisted a black bag from the trunk and opened the back door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He swallowed hard. Jenna had her feet on the floor, but her body was tipped over on the seat with Gavin tucked against her. Gavin had grown so much...and he’d missed it all. He’d caught glimpses of his son now and then and had photos, but he hadn’t been this close to him since his birth.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stuffed the bag onto the floor next to Jenna’s boots. “There’s a black parka in there and a wig and some brown contact lenses—nonprescription.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenna eased into a sitting position and twisted her head back and forth, taking in the empty alley behind the gas station. “This is weird. Why do you have this stuff?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For an occasion like this.” He crouched down and pawed through the bag. “I don’t have any clothes for Gavin, but I do have this.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenna’s eyes widened at the electric trimmer in his hand. “He doesn’t need a shave.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade cracked a smile. “It’s for his hair. Give him a buzz cut.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh.” Jenna ran her fingers through Gavin’s brown, curly locks. “And what about you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He lifted a shoulder. “They don’t know what I look like.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sitting sideways in his seat with his gun in his lap, Cade kept one eye on the parking lot in front of them and one eye on Jenna in the backseat, shrugging off her blue jacket and stuffing her arms into the black one.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She slicked back her hair and tugged the wig over her head. A cascade of brown waves fell over her shoulders as she flipped her head back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Contacts?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“In the side pocket.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She hunched over the bag and then leaned between the front seats to look in the rearview mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade adjusted it for her and she scooted in closer, the scent of her light floral perfume stealing over him and taking him back to summer nights in San Diego and the bougainvillea that crept up the trellis on her patio.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She caught his eye in the mirror. “Better?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nodded at the brown-eyed stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Digging through her purse, she said, “Might as well have the makeup match the coloring.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Whatever that meant.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Again, she leaned forward, this time the long hair of the wig brushing the shoulder of his jacket. She pinched a small brush between two fingers and stroked it over her eyebrows, darkening them to match the hair. Next came black mascara, applied liberally over her long lashes. She blinked and then swiped a tube of lipstick across her lush lips, turning her mouth into a dark pink pout.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade cocked his head. Maybe she should’ve gone mousy instead of glam.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?” She was studying him in the mirror, a pink blush heightening her color—a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural")]), _vm._v(" pink blush.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s just...I don’t know.” He ran a hand through his own short hair. “You look incredible. You’re going to attract a lot of attention.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But I don’t look like Jenna James.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, you don’t look like Jenna James, the single mom and waitress at the Lovett Brewing Company.” That Jenna James would have to disappear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She flattened her lips into a straight line. Hadn’t she realized he’d been keeping tabs on her and Gavin these past three years? Probably thought he’d forgotten all about them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He didn’t blame her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you done?” He held up the clippers. “Do you want to do the honors, or do you want me to do it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We can’t cut off all his hair while he’s sleeping.” She brushed Gavin’s curls from his forehead. “That’s a violation of his trust.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("What did he know about raising kids?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Can you wake him up?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She continued stroking Gavin’s face. “Wake up, sleepyhead.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin murmured and rubbed a fist under his nose, and Jenna squeezed his shoulder. “Wake up, Gavin.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He blinked his eyes and popped up. He clapped both hands over his mouth and giggled. “Mommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She tickled his cheek with the ends of her long hair. “Do you like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You look funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you.” She thrust her hand, palm up, over Cade’s shoulder. “Do you want to look funny, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh-huh.” He bounced in his seat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade slapped the electric hair clippers into her hand and she showed it to Gavin. “Do you want a haircut?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin pointed into the front seat. “Like him?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenna’s gaze flicked to Cade, her newly brown eyes narrowed. “Yeah, sort of like him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She pushed open the back door away from the entrance to the parking lot. “Scoot over here, so your hair will fall outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She flicked on the switch of the clippers, which vibrated in her hand, and ten minutes later, Gavin ran his hand over his buzz cut, grinning from ear to ear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I wanna see.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She scooped him onto her lap so he could see in the rearview mirror. Gavin giggled again, and a smile tugged at Cade’s lips.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay, now that you both look funny, let’s go to Lovett Peak Ski Resort and get something to eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Isn’t that kind of...public?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Exactly.” He started the car and snapped on his seat belt. “It won’t be easy for them to...uh...snatch their cargo in the middle of a ski resort, even if it does occur to them to look there.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenna’s creamy skin paled even more, and Cade mentally gave himself a good, swift kick. If she didn’t realize those guys were after Gavin, she did now. But maybe she needed to know.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade pulled the car into the parking lot of the ski resort, maneuvering around skiers and snowboarders packing it in for the day. He parked the car and waited while Jenna zipped up Gavin’s jacket and pulled his mittens onto his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When Jenna had Gavin properly bundled, Cade slipped his weapon in the inside pocket of his jacket and got out of the car. He opened Jenna’s door and stood toe-to-toe with her for the first time since he’d blasted back into her life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You look good, Jenna.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, because I just caked on about two inches of makeup.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He caught a long strand of the wig as it fluttered outside her hood and wrapped it around his finger. “I meant even before the disguise.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, you mean when I was tearing down the street with my son tucked under my arm after just witnessing...” She trailed off, glancing down at Gavin crushed against her side.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I mean...” She had no intention of making this easy on him. He disengaged his finger and yanked the hood off her head. “You’re a brunette. Let the casual observer see that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They crunched across the parking lot as a light snow began to fall. More skiers and snowboarders headed to their cars or the city and hotel shuttle buses, the boarders clomping along in their heavy boots.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin pointed a mittened hand at one of them. “Snowboard.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade’s hand hovered above Gavin’s head. He wanted to pick up his son, but would he allow that? Would his mother? “Have you been on a snowboard yet, Gavin?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No.” He skipped once and slipped on the slushy snow at the edge of the parking lot.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("To save Gavin from a fall, Cade scooped him up in his arms and buried his face in his neck. He didn’t smell like a baby anymore. He smelled sticky and a little grungy. Just like a boy should.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin laughed and kicked his legs. “Tickles.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade released a pent-up breath. At least his son hadn’t pushed him away. “I’m ticklish, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He met Jenna’s eyes over Gavin’s head. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ouch.")]), _vm._v(" Did her blue eyes have as much fire as this brown pair? Or had he just forgotten?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Never. He remembered every minute detail of Jenna’s face...and body.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh, I’ll just carry him to the lodge, if that’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s okay with me.” She shrugged. “And Gavin is friendly. He’ll go with anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Double ouch.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They climbed the stairs to the cafeteria situated in the resort’s ski lodge. As Cade suspected, the après-ski crowd filled the restaurant, bodies, equipment and winter clothing taking up every spare inch of the place. He saw a few empty tables, but he didn’t want to split up from Jenna while someone grabbed a table and someone else grabbed the food.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What sounds good?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenna tipped her chin at the counter for Italian food. “Gavin likes pizza and there should be some pasta there, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Italian, it is.” Cade continued to hold Gavin so he could point out what kind of pizza he wanted, while he and Jenna decided on some pastas and sauces.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenna carried one tray with Gavin clinging to the pocket of her black jacket, and Cade gripped the other tray while negotiating the tables scattered around the cafeteria.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He zeroed in on a table by the fireplace where a set of parents and two kids were gathering their jackets and gloves. “Are you leaving?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The dad handed a plastic tray to his son. “Yeah. Crazy in here, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Crazy.” Cade nodded. He pulled out a plastic chair for Jenna with one hand as he set the tray down with the other. Gavin crawled into the chair next to his mom’s.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After several minutes of settling in, Jenna went for the throat. “So why are those people after us and what are you doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nothing like getting right to the point.” His gaze flicked to Gavin, picking slices of pepperoni off his pizza and lining them up on his plate.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve been with you for almost an hour, and I still don’t have answers—not that I expect many.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t give you the details, Jenna. Just know you and Gavin have been on my radar ever since...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ever since you left us.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He hunched over the table and whispered, “You know I didn’t have a choice.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I guess that’s my fault. Should’ve never run off to Vegas with a drunken SEAL.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade’s pasta slid down his throat the wrong way and he choked. He chugged half his bottle of water to wash it down. “I was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" drunk. I knew exactly what I was doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her lip trembled and she dabbed at a strand of cheese hanging from Gavin’s chin. “That makes it worse. You knew you could never have a wife...a family, and you went ahead and married me, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I didn’t realize the full extent of the danger. When Jack Coburn recruited me...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She smacked the table and the salt-and-pepper shakers jumped. “If I hear Jack Coburn’s name one more time, I’m gonna puke.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin had jerked when Jenna hit the table, but now a big smile split his pizza-stained face and he giggled. “Mommy’s gonna puke.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This time Cade snorted water out of his nose. Eating with these two was hazardous to his health...almost as hazardous as his job was to theirs.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Smiling, Jenna swiped a napkin across Gavin’s face. “Not really, silly.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wiped the smile off her face just as quickly. “Why now, Cade? Did they step up their efforts to find us or did they just get lucky? Is there a fresh, new reason why we’re back in their sights, or have we always been there?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not safe to tell you, Jenna.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You mean it could actually get worse than living on the run, looking over my shoulder, being separated from...my family?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her words stung, but in a way she’d been right. It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" all his fault. If he hadn’t met her in Coronado, if he hadn’t fallen for her harder than he’d ever fallen for any woman before, if he hadn’t wanted to make her his wife, she’d be living a normal, happy life with some other guy. A safe guy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She sighed and tossed her napkin onto her plate. “If you’re not going to come clean, let’s blow this joint.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay, I suppose we should stop and get Gavin a car seat before we head to our next destination, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Next destination? And where would that be?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Someplace safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We can’t get a car seat at this time. Any store here that would have them is too far away and probably closed.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I guess we’ll have to keep him hidden.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shoved back her plastic chair so hard that it almost hit the floor. “Wouldn’t be the first time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They dumped their trash in the can and stacked their trays on top. Nobody gave them a second look—a typical family on a ski vacation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The light flakes of snow had dissipated, and the night sky had cleared to a deep midnight-blue so sharp it looked as if it could shatter into a million pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenna opened the back door and tucked Gavin into the corner of the seat, snapping a seat belt around his waist. “Just this once you go without a car seat because we don’t have one and it’s too late to buy one.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin yawned and nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenna hung on the car door. “Am I sitting up front this time?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not a great idea just yet. Why don’t you snuggle up with Gavin in the back? I have a couple of blankets in the trunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She gave an exaggerated sigh, but he didn’t believe for a minute she would be all that comfortable riding out of town shotgun.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He gathered one of the blankets from the trunk and tossed it onto her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cranking on the engine and the heater, he adjusted his rearview mirror. He hoped he hadn’t made a mistake hanging around town.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He turned back onto the one highway in and out of Lovett Peak and the car rolled smoothly over the newly plowed asphalt. Traffic began to back up, and he slowed down, trying to peer ahead at the commotion.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When he curved around the next bend, he swore under his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s a police stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What does that mean, a police stop?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The police are stopping cars, Jenna.” He swiveled his head around to the right, but no escape magically appeared. A solid barrier between his lane and the oncoming traffic put an end to any ideas of a wide U-turn in the middle of the highway. The cops would be all over some car trying to avoid the stop.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“D-do you think it’s a drunk-driving stop?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Could be.” Cade slid his gun from his inside pocket and stored it beneath his seat. “Is Gavin sleeping?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You need to cover him and yourself with that blanket. If you can get down on the floor of the car, that’s better.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The rustling in the backseat told him Jenna had complied with no fuss. Then it hit him. She was accustomed to looking over her shoulder. Thanks to him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She asked in a muffled voice, “What are they doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shh. Waving most people through. I think we’re okay. No more talking.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Despite the snowdrifts on the side of the road, a trickle of sweat rolled down Cade’s spine. One cop per lane ducked toward every window, said a few words and waved the driver through. He was up in two more cars.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He blew out a breath and rolled back his shoulders. He stretched his lips wide to practice a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rolling to a stop, he buzzed down his window. “What’s going on, Officer?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re looking for a woman with a child.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade peeled his tongue from the roof of his dry mouth. “Missing persons?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ah, persons of interest.” The cop flashed his light into the car, and Cade tensed his muscles.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did you do some skiing?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No. Just visited a friend.” Cade loosened his clammy grip on the steering wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The beam of light intruded into the backseat and Cade held his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sir, what’s under the blanket on the floor?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I have a blanket on the floor?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You do, sir, and I’m going to have to ask you to show me what’s underneath.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cade’s calf ached as it hovered over the accelerator.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He reached for the keys as if preparing to shut off the ignition. Instead, he jammed his foot down on the gas pedal, and his car, with its 450-horsepower engine, lunged forward with a squeal and a roar.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-8"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ebe9b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 78
// module chunks = 0